import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Caution } from "@faire/web--source/slate/icons/foundation/Caution";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IDisclaimer } from "@faire/web-api--source/indigofair/data/IDisclaimer";
import React from "react";
import styled from "styled-components";
export var Disclaimer = function(param) {
    var disclaimer = param.disclaimer;
    var message = disclaimer.message, background_color = disclaimer.background_color, icon = disclaimer.icon, text_color = disclaimer.text_color, help_link = disclaimer.help_link;
    return /*#__PURE__*/ _jsxs(MainWrapper, {
        $bgColor: background_color,
        children: [
            icon === IDisclaimer.Icon.CAUTION ? /*#__PURE__*/ _jsx(Caution, {
                fontSize: "18px"
            }) : null,
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                color: text_color,
                children: [
                    message,
                    help_link ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            " ",
                            /*#__PURE__*/ _jsx(EmbeddedLink, {
                                linkTo: help_link,
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "+W5vol",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Learn More"
                                        }
                                    ]
                                })
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
var MainWrapper = styled.div.withConfig({
    componentId: "sc-667508d2-0"
})([
    "width:100%;padding:12px;background-color:",
    ";display:flex;"
], function(props) {
    var _props_$bgColor;
    return (_props_$bgColor = props.$bgColor) !== null && _props_$bgColor !== void 0 ? _props_$bgColor : "none";
});
